<template>
    <div id="content">
        <div id="search" class="bg-light rounded d-block">
            <b-form @submit.prevent.stop="onSearch" @reset="onSearchReset" inline>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.city"
                               v-model="search.city"></b-form-select>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.vehicleCategory"
                               v-model="search.category"></b-form-select>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.vehicleLevel"
                               v-model="search.level"></b-form-select>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.status"
                               v-model="search.status"></b-form-select>
                <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0 text-danger" v-model="search.isPhoneShared">Numara Paylaşılan</b-form-checkbox>
                <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0 text-danger" v-model="search.isFake">Sahte</b-form-checkbox>
                <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0" v-model="search.active">is Active</b-form-checkbox>

                <div class="ml-auto">
                    <b-button type="reset" class="mb-2 mr-sm-2 mb-sm-0">Reset</b-button>
                    <b-button type="submit" variant="primary" class="mb-2 mb-sm-0" :disabled="loading">Search</b-button>
                </div>
            </b-form>
        </div>

        <loader v-if="loading"></loader>
        <div id="list" v-else>
            <div v-if="data.data.length > 0">
                <b-table  striped hover :items="data.data" :fields="['id', '#', 'user', 'driver', 'status', 'city', 'level', 'payment', 'NumPay', 'Sahte', 'createdAt']">

                    <template v-slot:cell(id)="data">
                        <router-link style="font-size: 12px;" :to="{ name: 'tripDetail', params: { id: data.value }}">{{data.value}}</router-link>
                    </template>

                    <template v-slot:cell(#)="data">
                        <b-icon scale="5" v-if="data.item.active" icon="dot" variant="success"></b-icon>
                        <b-icon scale="5" v-else icon="dot" variant="secondary"></b-icon>
                    </template>

                    <template v-slot:cell(user)="data">
                        <router-link :to="{ name: 'userDetail', params: { id: data.value.id }}">{{data.value.name}} {{data.value.surname}}</router-link>
                    </template>

                    <template v-slot:cell(driver)="data">
                        <router-link :to="{ name: 'userDetail', params: { id: data.value.id }}">{{data.value.name}} {{data.value.surname}}</router-link>
                    </template>

                    <template v-slot:cell(status)="data">
                        <span style="font-size: 10px;" class="badge badge-success">{{data.value}}</span>
                    </template>

                    <template v-slot:cell(NumPay)="data">
                        <b-icon scale="5" v-if="data.item.isPhoneShared" icon="dot" variant="danger"></b-icon>
                    </template>

                    <template v-slot:cell(Sahte)="data">
                        <b-icon scale="5" v-if="data.item.isFake" icon="dot" variant="danger"></b-icon>
                    </template>

                    <template v-slot:cell(city)="data">
                        {{data.value.name.substring(0,3)}}
                    </template>

                    <template v-slot:cell(level)="data">
                        {{data.value.name}}
                    </template>

                    <template v-slot:cell(payment)="data">
                        {{data.value.price}}₺
                        <span v-if="data.value.paymentType === 'CASH'" class="badge badge-light">Nakit</span>
                        <span v-if="data.value.paymentType === 'CARD'" class="badge badge-info">Kart</span>
                    </template>

                    <template v-slot:cell(createdAt)="data">
                        {{ data.value | moment("DD/MM/YYYY HH:mm") }}
                    </template>
                </b-table>
                <div class="ml-auto">
                    <b-pagination
                            @change="setPage"
                            :disabled="loading"
                            align="right"
                            v-model="data.page"
                            :total-rows="data.total"
                            :per-page="search.perPage"
                    ></b-pagination>
                </div>
            </div>

            <div class="card text-center" v-else>
                <div class="card-body">
                    <h5 class="card-title">Search Result</h5>
                    <p class="card-text">No Data</p>
                    <b-button @click="onSearchReset" variant="primary">Reset</b-button>
                </div>
                <div class="card-footer text-muted">
                    {{JSON.stringify(search)}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentLoader from '../../../components/ContentLoader';
    import GetTrips from '../../../store/actions/getTrips';
    import ShowError from '../../../helpers/showError';

    export default {
        name: 'Trips',
        components: {
            loader: ContentLoader,
        },
        created() {
            this.onSearch();
        },
        data() {
            return {
                data: {
                    data: []
                },
                loading: true,
                city: this.$store.state.city.map(item => ({text: item.name, value: item.id})),
                vehicleLevel: this.$store.state.vehicleLevel.map(item => ({text: item.name, value: item.id})),
                vehicleCategory: this.$store.state.vehicleCategory.map(item => ({text: item.name, value: item.id})),
                status: [
                    'REQUESTED',
                    'DRIVER_REQUESTED',
                    'DRIVER_ACCEPTED',
                    'DRIVER_ARRIVING',
                    'ON_TRIP',
                    'FINISHED',
                    'PAYMENT_ISSUE',
                    'DRIVER_REJECTED',
                    'USER_CANCELLED',
                    'DRIVER_CANCELLED',
                    'NO_NEAR_DRIVER',
                    'UNKNOWN_ERROR'
                ],
                search: {
                    perPage: 30,
                    page: 0,
                    city: undefined,
                    category: undefined,
                    level: undefined,
                    status: undefined,
                    isPhoneShared: undefined,
                    isFake: undefined,
                    active: null,
                    fields: ['id', 'active', 'user', 'driver', 'status', 'city', 'level', 'payment', 'isPhoneShared', 'isFake', 'createdAt']
                }
            }
        },
        methods: {
            setPage(page) {
                this.search.page = page;
                this.onSearch();
            },
            async onSearch() {
                try {
                    this.loading = true;
                    this.data = await GetTrips(this.search);
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            },
            onSearchReset() {
                this.search = {
                    perPage: 30,
                    page: 0,
                    city: undefined,
                    category: undefined,
                    level: undefined,
                    status: undefined,
                    active: null,
                    isPhoneShared: undefined,
                    isFake: undefined,
                    fields: this.search.fields
                };
                this.onSearch();
            }
        }
    }
</script>


<style scoped>
    #search {
        margin: 10px 0;
        padding: 10px;
    }
</style>
